import { Logger, LoggerService } from '@Shared/logger';
import { PipelineContext, PipelineStep } from '@Modules/pipeline_module/_base';
import { AppleService } from '@Modules/apple_module';
import { ScreenManager } from '@Modules/ui_module';
import { HandleCallbackRedirectStep } from '@Modules/pipeline_module/steps/auth/handle-callback-redirect.step';

export class AppleCallbackStep implements PipelineStep {
  private Logger: Logger = LoggerService.createLogger('AppleCallbackStep');

  constructor() {
    this.Logger.trace('****  CTOR ****');
  }

  async execute(context: PipelineContext): Promise<PipelineStep | null> {
    this.Logger.trace('Executing....', context);
    try {
      context.appleAccessToken =
        await AppleService.Instance.resolveAppleAccessToken();
    } catch (error) {
      this.Logger.error('Apple sub check error', error);
      context.appleAccessToken = null;
      this.showError();
    }
    context.isAppleCallback = true;
    return new HandleCallbackRedirectStep();
  }

  private showError(): void {
    try {
      const screenManager = ScreenManager.Instance;
      screenManager.showScreen('login');
      screenManager.CurrentScreen?.Alert?.error(
        'There was an error in logging you in, please try again.',
      );
    } catch (e) {
      this.Logger.warn('Unable to surface Apple error via ScreenManager', e);
    }
  }
}
